"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const core_1 = require("@bem-react/core");
const desktop_1 = require("@yandex-lego/components/Icon/desktop");
const q_date_1 = require("./type/q-date");
const loop_1 = require("./type/loop");
const zoom_in_1 = require("./type/zoom-in");
const zoom_out_1 = require("./type/zoom-out");
const cross_1 = require("./type/cross");
// eslint-disable-next-line import/prefer-default-export
exports.Icon = (0, core_1.compose)((0, core_1.composeU)(desktop_1.withGlyphCaretsV, desktop_1.withGlyphXSign), (0, core_1.composeU)(q_date_1.withTypeQuestionDate, loop_1.withTypeLoop, zoom_in_1.withTypeZoomIn, zoom_out_1.withTypeZoomOut, cross_1.withTypeCross))(desktop_1.Icon);
